import {LoginResponse} from './login/login'
export class User{
    public status:boolean;
    public message:string;
    public data: LoginResponse
}